import React, { useState, useEffect, useRef } from 'react'
import Layout from '../components/Layout'
import api from '../services/api'
import { useParams, useNavigate } from 'react-router-dom'

export default function QRCodePage() {
  const { id } = useParams()
  const navigate = useNavigate()
  const [contract, setContract] = useState(null)
  const [qrData, setQrData] = useState(null)
  const [loading, setLoading] = useState(true)
  const printRef = useRef(null)

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { fetchQRCode() }, [id])

  const fetchQRCode = async () => {
    try {
      setLoading(true)
      const [contractRes, qrRes] = await Promise.all([
        api.get(`/contracts/${id}`),
        api.get(`/contracts/${id}/qr`)
      ])
      if (contractRes.data.success) setContract(contractRes.data.data)
      if (qrRes.data.success) setQrData(qrRes.data)
    } catch (err) { console.error(err) }
    finally { setLoading(false) }
  }

  const handlePrint = () => window.print()

  if (loading) return <Layout><div style={{ textAlign: 'center', padding: '80px', color: '#94a3b8' }}>กำลังโหลด...</div></Layout>

  if (!contract || !qrData) return (
    <Layout>
      <div style={{ textAlign: 'center', padding: '80px' }}>
        <p style={{ color: '#94a3b8', marginBottom: '12px' }}>ไม่พบข้อมูลสัญญา</p>
        <button onClick={() => navigate('/contracts')} style={{ color: '#075dcc', background: 'none', border: 'none', cursor: 'pointer', fontSize: '13px' }}>กลับหน้าสัญญา</button>
      </div>
    </Layout>
  )

  return (
    <Layout>
      <div style={{ maxWidth: '480px', margin: '0 auto' }}>

        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '24px' }}>
          <div>
            <h1 style={{ fontSize: '20px', fontWeight: '500', color: '#0f172a' }}>QR Code สำหรับเซ็นสัญญา</h1>
            <p style={{ fontSize: '13px', color: '#94a3b8', marginTop: '4px' }}>พิมพ์และส่งให้พนักงานสแกน</p>
          </div>
          <button onClick={() => navigate('/contracts')} style={{ fontSize: '13px', color: '#64748b', background: 'none', border: 'none', cursor: 'pointer' }}>← กลับ</button>
        </div>

        {/* Card สำหรับพิมพ์ */}
        <div ref={printRef} style={{ background: 'white', borderRadius: '16px', border: '0.5px solid #e2e8f0', padding: '32px', textAlign: 'center' }}>

          {/* Header */}
          <div style={{ marginBottom: '20px' }}>
            <div style={{ width: '48px', height: '48px', background: '#075dcc', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px' }}>
              <i className="ti ti-file-certificate" style={{ color: 'white', fontSize: '22px' }} />
            </div>
            <p style={{ fontSize: '15px', fontWeight: '500', color: '#0f172a' }}>สัญญาจ้างพนักงาน</p>
            <p style={{ fontSize: '13px', color: '#94a3b8' }}>เทศบาลนครมาบตาพุด</p>
          </div>

          {/* ข้อมูลพนักงาน */}
          <div style={{ background: '#f8fafc', borderRadius: '12px', padding: '16px', marginBottom: '20px', textAlign: 'left' }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
              {[
                ['ชื่อ-นามสกุล', `${contract.prefix}${contract.first_name} ${contract.last_name}`],
                ['เลขสัญญา', contract.contract_no],
                ['ตำแหน่ง', contract.position || '-'],
                ['กองงาน', contract.division_name || '-'],
                ['วันที่เริ่ม', new Date(contract.start_date).toLocaleDateString('th-TH')],
                ['วันที่สิ้นสุด', new Date(contract.end_date).toLocaleDateString('th-TH')],
              ].map(([label, value]) => (
                <div key={label}>
                  <p style={{ fontSize: '11px', color: '#94a3b8' }}>{label}</p>
                  <p style={{ fontSize: '13px', fontWeight: '500', color: '#0f172a', marginTop: '1px' }}>{value}</p>
                </div>
              ))}
            </div>
          </div>

          {/* QR Code */}
          <div style={{ marginBottom: '20px' }}>
            <div style={{ display: 'inline-block', background: '#f8fafc', borderRadius: '14px', padding: '12px' }}>
              <img src={qrData.qrCode} alt="QR Code" style={{ width: '192px', height: '192px', display: 'block' }} />
            </div>
            <p style={{ fontSize: '12px', color: '#94a3b8', marginTop: '12px' }}>สแกน QR Code เพื่อเซ็นสัญญา</p>
            <p style={{ fontSize: '11px', color: '#cbd5e1', marginTop: '2px' }}>หมดอายุ {new Date(qrData.expires_at).toLocaleString('th-TH')}</p>
          </div>

          {/* คำแนะนำ */}
          <div style={{ background: '#eff6ff', borderRadius: '12px', padding: '14px', textAlign: 'left' }}>
            <p style={{ fontSize: '12px', fontWeight: '500', color: '#3730a3', marginBottom: '8px' }}>วิธีใช้งาน</p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              {['เปิดกล้องมือถือสแกน QR Code', 'อ่านสัญญาและตรวจสอบข้อมูล', 'ยอมรับข้อตกลง PDPA', 'วาดลายเซ็น แล้วกดยืนยัน'].map((step, i) => (
                <p key={i} style={{ fontSize: '12px', color: '#0646a6' }}>{i + 1}. {step}</p>
              ))}
            </div>
          </div>
        </div>

        {/* ปุ่ม */}
        <div style={{ display: 'flex', gap: '10px', marginTop: '16px' }}>
          <button onClick={() => navigate('/contracts')}
            style={{ flex: 1, padding: '10px', background: 'white', color: '#64748b', border: '0.5px solid #e2e8f0', borderRadius: '10px', fontSize: '13px', cursor: 'pointer' }}>
            กลับหน้าสัญญา
          </button>
          <button onClick={handlePrint}
            style={{ flex: 1, padding: '10px', background: '#075dcc', color: 'white', border: 'none', borderRadius: '10px', fontSize: '13px', fontWeight: '500', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
            <i className="ti ti-printer" style={{ fontSize: '15px' }} />
            พิมพ์ QR Code
          </button>
        </div>
      </div>
    </Layout>
  )
}
